<template>
    <el-dialog class="el-dialogs" :title="title" width="400px" :close-on-click-modal="false" :visible.sync="visible">
        <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
                 @keyup.enter.native="doSubmit()" @submit.native.prevent
                 label-width="110px">
            <el-form-item label="渠道名称：" prop="channelName">
                <el-input v-model.trim="searchForm.channelName" maxlength="20"
                          placeholder="请输入渠道名称(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item label="排序：" prop="sort">
                <el-input-number v-model="searchForm.sort" @change="setSort" :min="1"
                                 label="请输入排序"></el-input-number>
            </el-form-item>
            <el-form-item label="栏目管理：" prop="columnStatus">
                <el-switch
                        v-model="searchForm.columnStatus"
                        active-value="0"
                        inactive-value="1">
                </el-switch>
            </el-form-item>
            <el-form-item label="显示状态：" prop="status">
                <el-switch
                        v-model="searchForm.status"
                        active-value="0"
                        inactive-value="1">
                </el-switch>
            </el-form-item>
            <template v-if="title == '修改渠道'">
                <el-form-item label="创建人：" prop="createByName">
                    <div>{{ searchForm.createByName }}</div>
                </el-form-item>
                <el-form-item label="创建时间：" prop="createTime">
                    <div>{{ searchForm.createTime }}</div>
                </el-form-item>
                <el-form-item label="最后修改人：" prop="updateByName">
                    <div>{{ searchForm.updateByName }}</div>
                </el-form-item>
                <el-form-item label="最后修改时间：" prop="updateTime">
                    <div>{{ searchForm.updateTime }}</div>
                </el-form-item>
            </template>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "addChannel",
    data() {
        return {
            title: '新增渠道',
            visible: false,
            searchForm: {
                channelName: '',
                sort: 1,
                columnStatus: '1',
                status: '1',
            },
            rules: {
                channelName: [
                    {required: true, message: '请输入渠道名称', trigger: 'blur'}
                ],
            },
        }
    },

    methods: {
        init(row) {
            this.visible = true
            this.searchForm = {
                channelName: '',
                sort: 1,
                columnStatus: '1',
                status: '1',
            }
            this.$nextTick(() => {
                this.$refs.searchForm.resetFields();
            })
            if (row) {
                this.title = '修改渠道'
                this.$axios(this.api.dyygRelease.releasesChannelGetById + row.id, {}).then(data => {
                    if (data && data.status) {
                        this.searchForm = data.data
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            } else {
                this.title = '新增渠道'
            }
        },

        setSort(value) {
            if (!value) {
                this.searchForm.sort = 1
            }
        },


        //提交
        doSubmit() {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    if (this.searchForm.id) {
                        this.$axios(this.api.dyygRelease.releasesChannelUpdateById, this.searchForm, 'put').then(data => {
                            if (data && data.status) {
                                this.$message.success('修改成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        this.$axios(this.api.dyygRelease.releasesChannelSave, this.searchForm, 'post').then(data => {
                            if (data && data.status) {
                                this.$message.success('提交成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            });
        },
    },
}
</script>

<style scoped>
.el-dialogs >>> .el-dialog__body {
    height: auto !important;
}
</style>